import { Link } from 'react-router-dom';
import { cn } from '../../utility/base';
import { buttonVariants } from '@playcastdotio/Shadcn';
import config from '../../config.json';
import { useEffect } from 'react';

export const Discord = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div className='bg-content text-content-text m-0 h-auto w-full p-0'>
      <div className='bg-hero bg-content text-content-text m-0 h-auto w-full bg-cover bg-no-repeat p-0'>
        <div className='container mx-auto h-auto w-full px-8 pb-8 pt-20'>
          <section id='hero' className='grid grid-cols-12 gap-x-4 gap-y-8'>
            <div className='grid-rows col-span-full grid content-center gap-y-4 md:col-span-6 lg:gap-y-8'>
              <h1 className='row-auto text-3xl font-bold lg:text-4xl'>Join the Community!</h1>
              <p className='row-auto'>
                Join the growing group of Playcasters on Discord to chat with our team and other streamers and report bugs you find so we
                can fix them as soon as possible. If you’re interested in becoming a UX Tester you can the dedicated channel on Discord and
                help shape the future of Playcast!
              </p>
              <Link to={config.DISCORD_URL} className={cn(buttonVariants(), 'w-fit rounded-full bg-amber-400')}>
                Join The Discord
              </Link>
            </div>

            <div className='col-span-full content-center md:col-span-5 md:col-start-8'>
              <img src='/images/preview-image.png' alt='screenshot' />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
